import React from "react";
import "./Header.css";
import CTA from "./CTA";
//import ME from "../../assets/me.jpg";
import HeaderSocial from "./HeaderSocial";
const Header = () => {
  return (
    <header>
      <div className="container header__container">
        <h5>Hello I'm</h5>
        <h1>Emmanuel Gyimah</h1>
        <h5 className="text-light">Web Developer</h5>
        <CTA />
        <HeaderSocial />
        <div className="me">
          <div className="overlay"></div>
        </div>
        <a href="#contacts" className="scroll__down">
          Scroll Down
        </a>
      </div>
    </header>
  );
};

export default Header;
